import * as React from "react";
import {useEffect} from "react";
import {Box, LockStatus} from "@variocube/app-api";
import {classNames, layout, MessageView, PushButton, useBoxLockStatus} from "@variocube/cube-ui";
import {useLocalization} from "../i18n";

interface BoxCloseProps {
    box: Box;
    onDone: () => any;
    showClose?: boolean;
}

export function BoxClose({box, onDone, showClose}: BoxCloseProps) {
    const status = useBoxLockStatus(box.number);
    const {t} = useLocalization();

    useEffect(() => {
        if (status == LockStatus.Closed) {
            onDone();
        }
    }, [status, onDone]);

    return (
        <MessageView message={t("CloseBoxMessage", {boxNumber: box.number})}>
            <div className={classNames(layout.fill, layout.horizontal, layout.center)}>
                {showClose && (
                    <PushButton onClick={onDone}>
                        {t("Close")}
                    </PushButton>
                )}
            </div>
        </MessageView>
    )
}